import React from 'react';
import TextInput from '../../../components-library/inputs/TextInput';
import { DeliveryAddressSchema } from '../../../modules/mobile/modals/delivery-address/form/schema';
import { Controller, useFormContext } from 'react-hook-form';
import useTheme from '../../../hooks/ui/useTheme';
import { useTranslation } from 'react-i18next';

interface FormItem {
  key: keyof DeliveryAddressSchema;
  placeholder: string;
  autoComplete?: string;
  type?: 'text' | 'number' | 'uppercase';
}

const formItems: FormItem[] = [
  {
    key: 'delivery_street_name',
    placeholder: 'text_inputs.street_name.placeholder',
  },
  { key: 'delivery_street_number', placeholder: 'text_inputs.street_number.placeholder' },
  { key: 'delivery_city', placeholder: 'text_inputs.city.placeholder' },
  { key: 'delivery_zip_code', placeholder: 'text_inputs.zip.placeholder', autoComplete: 'postal-code' },
];

const DeliveryAddressForm = () => {
  const deliveryAddressForm = useFormContext();
  const theme = useTheme();
  const { t } = useTranslation(null, { keyPrefix: 'Modals:OrderMethod:OrderMethodModal' });

  return (
    <form className="flex flex-wrap items-center gap-y-md gap-x-md">
      {formItems.map((item) => (
        <Controller
          key={item.key}
          name={item.key}
          control={deliveryAddressForm.control}
          render={({ field: { ref: _ref, ...field }, fieldState }) => (
            <div className="basis-[calc(50%-8px)]">
              <TextInput
                {...field}
                containerStyle={{
                  borderColor: fieldState.error?.message ? theme.color.danger : undefined,
                }}
                className="placeholder:text-danger"
                type={item.type}
                autoComplete={item.autoComplete}
                placeholder={t(item.placeholder)}
              />
            </div>
          )}
        />
      ))}
    </form>
  );
};

export default DeliveryAddressForm;
